import * as React from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { User, Briefcase, Globe, ChevronDown } from "lucide-react";
import { all } from "axios";

const FilterDropdown = ({ categories, setFilter }) => {
  const [selectedFilter, setSelectedFilter] = React.useState("");

  const handleSelect = (category) => {
    setSelectedFilter(category.ledger);
    setFilter(category._id);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="flex items-center gap-2">
          {selectedFilter || "All Category"} <ChevronDown />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem key={1} onClick={() => handleSelect("")}>
          All Category
        </DropdownMenuItem>
        {categories?.map((category) => (
          <DropdownMenuItem
            key={category._id}
            onClick={() => handleSelect(category)}
          >
            {category.ledger}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default FilterDropdown;
